import { useShowSnackbar } from "@octopusdeploy/design-system-components";
import { useMutation } from "@octopusdeploy/octopus-react-client";
import type { ProjectTemplateResource, Repository, ShareProjectTemplateToManySpacesCommand } from "@octopusdeploy/octopus-server-client";
import type { SharedSpaces } from "../StopShareTemplateDialog";

export function useStopShareProjectTemplate(projectTemplate: ProjectTemplateResource, refetchIsTemplateShared: () => void) {
    const showSnackbar = useShowSnackbar();

    const { execute: handleStopShare } = useMutation({
        name: "Stop sharing project template",
        action: async (repository: Repository, sharedSpaces: SharedSpaces) => {
            const shareCommand: ShareProjectTemplateToManySpacesCommand = {
                ProjectTemplateSlug: projectTemplate.Slug,
                GitRef: projectTemplate.GitRef,
                ShareToAllSpaces: sharedSpaces.shareToAll,
                IndividuallySharedSpaceIds: sharedSpaces.individualSpacesSharedTo,
            };
            return await repository.ProjectTemplates.shareToSpace(shareCommand);
        },
        afterComplete: async () => {
            showSnackbar("Project template has been unshared from all spaces.");
            refetchIsTemplateShared();
        },
    });

    return { handleStopShare };
}
